import { AuthenticatorType } from '../../lib/allauth';
import AuthenticateCode from './AuthenticateCode';

export default function AuthenticateRecoveryCodes() {
  return (
    <AuthenticateCode authenticatorType={AuthenticatorType.TOTP}>
      <p className='text-gray-600 my-8'>
        Please enter the code from your authenticator app.
      </p>
    </AuthenticateCode>
  );
}
